// DOCS: https://system-of-record.dev.service.fundingoptions.com/customer/
import axios from 'axios';
import getServiceUrl, {Service} from '../getServiceUrl';
import getBearerToken from '../getBearerToken';
import {User} from '../../../types';

const serviceHost = getServiceUrl(Service.SYSTEM_OF_RECORD_SERVICE);
const SystemOfRecordService = axios.create({baseURL: serviceHost});

// Authorization header control
export interface SetAuthTokenOpts {
  token?: string;
  user?: User;
}
export const setAuthToken = ({token, user}: SetAuthTokenOpts): void => {
  const authToken = token ? `Bearer ${token}` : getBearerToken(user);
  if (authToken) {
    SystemOfRecordService.defaults.headers.common.Authorization = authToken;
  } else {
    delete SystemOfRecordService.defaults.headers.common.Authorization;
  }
};

export enum SOREndpoints {
  // customers
  CUSTOMER_APPLICATIONS = '/customer/application/',
  CUSTOMER_PROFILE = '/customer/account/',
  CUSTOMER_PRODUCT = '/customer/product/',
  CUSTOMER_SELECTED_PRODUCT = '/customer/product/selected/',
  MATCHES = '/matches',

  // post products
  POST_SELECT_PRODUCT = '/select-product',
  POST_ACCEPT_QUOTE = '/accept-quote',
  POST_ACCEPT_OFFER = '/accept-offer',

  // advisors
  ADVISOR_PROFILE = '/partner/account/',
  ADVISOR_REFERRALS = '/partner/referrals/',

  // open banking
  OPEN_BANKING = '/customer/open-banking/',
}

export default SystemOfRecordService;
